'use client';

import Link from 'next/link';
import { cn } from '@/core/utils/cn';
import { useTranslation } from '@/core/i18n';

/* -------------------------------------------------------------------------- */
/*  CTASection                                                                */
/* -------------------------------------------------------------------------- */

export function CTASection() {
  const { t } = useTranslation();
  return (
    <section id="hotels-cta-section" className="relative w-full overflow-hidden bg-hms-bg py-20 sm:py-28">
      {/* Radial gold glow */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            'radial-gradient(ellipse 70% 50% at 50% 50%, rgba(200,145,58,0.06) 0%, transparent 70%)',
        }}
      />

      <div className="relative mx-auto max-w-3xl px-4 text-center sm:px-6 lg:px-8">
        {/* Heading */}
        <h2
          className={cn(
            'text-3xl font-extrabold tracking-tight sm:text-4xl lg:text-5xl',
            'bg-gradient-to-r from-hms-gold via-hms-goldLt to-amber-400',
            'bg-clip-text text-transparent',
          )}
        >
          {t('ctaSection.title')}
        </h2>

        {/* Subtitle */}
        <p className="mx-auto mt-5 max-w-xl text-base text-hms-textSub sm:text-lg">
          {t('ctaSection.subtitle')}
        </p>

        {/* Buttons */}
        <div className="mt-10 flex flex-col items-center gap-4 sm:flex-row sm:justify-center">
          <Link
            id="hotels-cta-trial-btn"
            href="/register-hotel"
            className={cn(
              'flex items-center justify-center rounded-lg bg-hms-gold px-8 py-3.5',
              'text-sm font-semibold tracking-wide text-hms-bg',
              'transition-all duration-200 hover:bg-hms-gold/90',
              'w-full sm:w-auto',
            )}
          >
            {t('ctaSection.startFreeTrial')}
          </Link>
          <Link
            id="hotels-cta-demo-btn"
            href="/contact"
            className={cn(
              'flex items-center justify-center rounded-lg border border-hms-border px-8 py-3.5',
              'text-sm font-semibold tracking-wide text-hms-text',
              'transition-all duration-200 hover:border-hms-gold/40 hover:text-hms-gold',
              'w-full sm:w-auto',
            )}
          >
            {t('ctaSection.scheduleDemo')}
          </Link>
        </div>

        {/* Disclaimer */}
        <p className="mt-5 text-xs text-hms-textDim">
          {t('ctaSection.noCreditCard')}
        </p>
      </div>
    </section>
  );
}
